import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-10',
  templateUrl: './10.component.html',
  styleUrls: ['./10.component.scss'],
})
export class VbList10Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
